export default __webpack_public_path__ + "static/media/RosanaRodrigues_01.b4148ab7.jpg";